import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { castDraft } from 'immer';

import { UserNotification } from 'dashboard/models/user-notification';
import { PaginationParams } from 'lib/interfaces/api';

interface UserNotificationsPayload {
  userNotifications: UserNotification[];
  requestKey: string;
  paginationParams: PaginationParams | undefined;
}

export interface UserNotificationsDetails {
  userNotifications: UserNotification[];
  paginationParams: PaginationParams | undefined;
}

export interface UserNotificationsState {
  userNotifications: Record<string, UserNotificationsDetails>;
}

const initialState: UserNotificationsState = {
  userNotifications: {},
};

const userNotificationsSlice = createSlice({
  name: 'user-notifications',
  initialState,
  reducers: {
    saveUserNotifications: (state, action: PayloadAction<UserNotificationsPayload>) => {
      const { userNotifications, requestKey, paginationParams } = action.payload;

      state.userNotifications[requestKey] = {
        ...state.userNotifications[requestKey],
        userNotifications: castDraft(userNotifications),
        paginationParams: paginationParams,
      };
    },
    addUserNotifications: (state, action: PayloadAction<UserNotificationsPayload>) => {
      const { userNotifications, requestKey, paginationParams } = action.payload;

      state.userNotifications[requestKey] = {
        ...state.userNotifications[requestKey],
        userNotifications: [
          ...(state.userNotifications[requestKey]?.userNotifications ?? []),
          ...castDraft(userNotifications),
        ],
        paginationParams: paginationParams,
      };
    },
    clearUserNotifications: () => {
      return initialState;
    },
  },
});

export const { saveUserNotifications, addUserNotifications, clearUserNotifications } =
  userNotificationsSlice.actions;

export const userNotificationsReducer = userNotificationsSlice.reducer;
